import useEmployeeWorkInCalendar from "features/employee/hooks/useEmployeeWorkInCalendar";
import MyTeamCalendarComponent from "../components/MyTeamCalendar";
import useMyTeamCalendar from "../hooks/useMyTeamCalendar";

function MyTeamCalendar() {
  const useMyTeamCalendarProps = useMyTeamCalendar();
  return <MyTeamCalendarComponent {...useMyTeamCalendarProps} />;
}

export default MyTeamCalendar;
